import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const searchTlc = "/api/business/decision-volatility";
const searchCompany = "/api/business/companyList";
const exportExcel = "/api/business/decision-volatility/excel";
export default class FeeCodeListCpnService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getSearchReceipt(querySearch: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(searchTlc, querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllCompany(query?: any): Promise<any> {
    console.log(searchCompany);
    return new Promise<any>((resolve, reject) => {
      axios
        .post(searchCompany)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch(() => {});
    });
  }

  public ExportExcel(params: any, data?: any): Promise<any> {
    console.log(searchCompany);
    return new Promise<any>((resolve, reject) => {
      axios
        .post(exportExcel + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params), data, { responseType: "blob" })
        .then((resp) => {
          resolve(resp);
        })
        .catch(() => {});
    });
  }
}
